import { deleteTimeStreamProject } from '../actions';
import { orchestrator } from 'satcheljs';
import setProjectInLocalStorage from './setProjectInLocalStorage';

orchestrator(deleteTimeStreamProject, ({ projectId }) => {
    setProjectInLocalStorage(projectId, null);
});
